import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M22,3.77a1.53,1.53,0,0,0-.89-1.4A22.07,22.07,0,0,0,12,.5,22.07,22.07,0,0,0,2.89,2.37,1.53,1.53,0,0,0,2,3.77v7.64A12.27,12.27,0,0,0,9.83,22.88l1.07.41a3,3,0,0,0,2.2,0l1.07-.41A12.27,12.27,0,0,0,22,11.41ZM18.51,8.24l-6,8.23a1.25,1.25,0,0,1-1,.51,1.27,1.27,0,0,1-.88-.36L6,12a1.25,1.25,0,0,1,1.77-1.77l3.34,3.34a.25.25,0,0,0,.2.07.22.22,0,0,0,.18-.1l5-6.82a1.25,1.25,0,0,1,2,1.48Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }